import avocadoOil from "../../images/circleIcons/avocadoOil.png";
import ribeyesteak from "../../images/circleIcons/ribeyesteak.png";
import Sauerkraut from "../../images/circleIcons/Sauerkraut.png";
import Smartwatch from "../../images/circleIcons/Smartwatch.png";
import Tennisball from "../../images/circleIcons/Tennisball.png";
import Slicedbagel from "../../images/circleIcons/Slicedbagel.png";
import Dogtoys from "../../images/circleIcons/Dogtoys.png";
import KTV from "../../images/circleIcons/4KTV.png";
import Milk from "../../images/circleIcons/Milk.png";
import CoffeeBeans from "../../images/circleIcons/CoffeeBeans.png";

const questionAnswers = [
  {
    title: "DEMAND CURVE FOR AVOCADO OIL",
    question: "A record drought in Spain drives up the price of olive oil to a 26 year high.",
    subQuestion: "Consider the demand curve for avocado oil, a substitute for olive oil. What happens?",
    icon: avocadoOil,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "Olive oil and avocado oil are substitutes. If the price of olive oil increases, consumers will look for substitutes, including avocado oil. Demand for avocado oil will increase and the demand curve will shift right.",
  },
  {
    title: "DEMAND CURVE FOR PREMIUM RIBEYE STEAKS",
    question: 'Median real household income declines for the 3rd straight year.',
    subQuestion: "Consider the demand for premium ribeye steaks. What happens?",
    icon: ribeyesteak,
    answer: "shifts left",
    graphType: "demand curve",
    briefness:
      "Real incomes are declining. Demand for premium goods will decline as consumers switch to lower cost goods. Demand for normal goods, including premium ribeye steaks, will fall and the demand curve will shift left.",
  },
  {
    title: "DEMAND CURVE FOR SAUERKRAUT",
    question: "Researchers find more evidence that fermented foods like sauerkraut are good for your gut.",
    subQuestion: "Consider the demand curve for sauerkraut. What happens?",
    icon: Sauerkraut,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "The increased knowledge of the health benefits of sauerkraut will increase the number of consumers interested in sauerkraut and customers' willingness to pay. Demand for sauerkraut increases and demand shifts right.",
  },
  {
    title: "DEMAND CURVE FOR SMARTWATCHES",
    question: "An algorithm glitch causes the price of a new smartwatch to fall to $10.",
    subQuestion: "Consider the demand curve for smartwatches. What happens?",
    icon: Smartwatch,
    answer:  "goes up",
    graphType: "demand curve",
    briefness:
      "Only the price has changed. A lower price for smartwatches will increase the quantity of smartwatches demanded.",
  },
  {
    title: "DEMAND CURVE FOR TENNIS BALLS",
    question: "New technology lowers the cost of tennis rackets.",
    subQuestion: "Consider the demand curve for tennis balls. What happens?",
    icon: Tennisball,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "Tennis rackets and tennis balls are complementary goods. When the price of tennis rackets falls, the demand for tennis balls will increase, and the demand curve will shift to the right.",
  },
  {
    title: "DEMAND CURVE FOR SLICED BAGELS",
    question: "New York City introduces a new 8 cent tax on sliced bagels. ",
    subQuestion: "Consider the demand for sliced bagels. What happens?",
    icon: Slicedbagel,
    answer: "goes down",
    graphType: "demand curve",
    briefness:
      "Only the price has changed. The higher price will decrease the quantity demanded of sliced bagels.",
  },
  {
    title: "DEMAND CURVE FOR DOG TOYS",
    question: "Dog adoptions soar during the pandemic.",
    subQuestion: "Consider the demand curve for dog toys. What happens?",
    icon: Dogtoys,
    answer: "shifts right",
    graphType: "demand curve",
    briefness:
      "An increasing population of dogs and dog owners means that demand will increase for products that dog owners use, including dog toys. The demand curve shifts right.",
  },
  {
    title: "DEMAND CURVE FOR 4K TVs",
    question: "Tech magazines predict that 4K televisions will be significantly discounted for the holidays in a few months. ",
    subQuestion: "Consider the demand curve for 4K TVs right now. What happens?",
    icon: KTV,
    answer: "shifts left",
    graphType: "demand curve",
    briefness:
      "If consumers expect that prices will be dramatically lower in a few months, they will delay their current purchases. This will cause demand for 4K TVs right now to decrease and the demand curve will shift to the left.",
  },
  {
    title: "DEMAND CURVE FOR MILK",
    question: "Ping Pong tournaments rapidly rise in popularity.",
    subQuestion: "Consider the demand curve for milk. What happens?",
    icon: Milk,
    answer: "Nothing happens",
    graphType: "demand curve",
    briefness:
      "This was a trick question. Demand for milk and ping pong tournaments are not related. The rising popularity of ping pong will not impact the demand curve for milk or the quantity of milk demanded.",
  },
  {
    title: "DEMAND CURVE FOR COFFEE BEANS",
    question: "Coffee bean prices increase by $4 per pound.",
    subQuestion: "Consider the demand curve for coffee beans. What happens?",
    icon: CoffeeBeans,
    answer: "goes down",
    graphType: "demand curve",
    briefness: "Only the price has changed. A higher price will decrease the quantity demanded of coffee beans.",
  },
];

export default questionAnswers;
